import { removeCharFromString } from "@utils/removeCharFromString"

export const removeHashFromString = (str: string) => {
    return removeCharFromString(str, /#/g)
}
